import React, { useContext } from "react";
import { defineMessages, FormattedMessage, injectIntl, intlShape } from "react-intl";
import * as styles from "./InstallStyles.module.scss";
import { InstallContext } from "./InstallContext";
import { Spinner, Title } from "@yoast/ui-library";
import classnames from "classnames";
import { SkipInstallationFlowLink } from "./SkipInstallationFlowLink";

const messages = defineMessages( {
	loadingTitle: {
		id: "install.loadingTitle",
		defaultMessage: "Processing order…",
	},
	loadingTitleAfterOneMinute: {
		id: "install.LoadingTitleAfterOneMinute",
		defaultMessage: "This is taking longer than normal…",
	},
	text: {
		id: "install.text",
		defaultMessage: "On a busy day this could take up to a few minutes, please stand by.",
	},
	textAfterOneMinute: {
		id: "install.textAfterOneMinute",
		defaultMessage: "Your order is taking longer than expected to process. " +
			"Apologies for any inconvenience. Please try again later using the link provided in the order confirmation message we sent you.",
	},
} );

/**
 * Renders a component to check if an order exists in the my-yoast database.
 *
 * @returns {React.JSX.Element} The rendered component.
 */
const ProcessingOrder = () => {
	const { isPolling } = useContext( InstallContext );

	const titleMessage  = isPolling ? messages.loadingTitle : messages.loadingTitleAfterOneMinute;
	const textMessage   = isPolling ? messages.text : messages.textAfterOneMinute;

	return <div className={ classnames( styles.processingOrderStep, styles.textCenter, styles.ySpacing ) }>
		<Title><FormattedMessage { ...titleMessage } /></Title>
		<hr />
		<p><FormattedMessage { ...textMessage } /></p>
		{ isPolling && <Spinner className={ styles.spinner } variant={ "primary" } size={ "4" } /> }
		<hr />
		<SkipInstallationFlowLink />
	</div>;
};

ProcessingOrder.propTypes = {
	intl: intlShape.isRequired,
};

export default injectIntl( ProcessingOrder );
